import React, {useEffect} from 'react';
import { motion } from 'framer-motion';

import Transition from '../assets/Transition';
import Header from '../components/Header';

import Image from '../assets/header.webp';

const ThankYou = () => {
    useEffect(() => {
        document.title = "Thank You!";
    });
    
    return (
        <motion.div
            initial={{translateX: 50, opacity: 0}}
            animate={{translateX: 0, opacity: 1}}
            exit={{translateX: 50, opacity: 0}}
            transition={{duration: 0.6, ease: [0.43, 0.13, 0.23, 0.96]}}>
            <Header
                title="I'll be in touch!"
                tagline={<>Thank <span className='underline'>you</span> for reaching out!</>}
                image={Image}
                subtitle="ZOTY"/>
        </motion.div>
    );
};

export default Transition(ThankYou);